// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__14UQa","productName":"Table_productName__Fg1Qe"};